import { render, staticRenderFns } from "./recipelDetail.vue?vue&type=template&id=57e0863f&scoped=true&"
import script from "./recipelDetail.vue?vue&type=script&lang=js&"
export * from "./recipelDetail.vue?vue&type=script&lang=js&"
import style0 from "./recipelDetail.vue?vue&type=style&index=0&id=57e0863f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e0863f",
  null
  
)

export default component.exports